/**
 * Displays an error message in the given container.
 * The message is set via textContent to avoid XSS.
 */
export function showError(container: HTMLElement, message: string): void {
  let el = container.querySelector<HTMLParagraphElement>('.error-message')
  if (!el) {
    el = document.createElement('p')
    el.className = 'error-message'
    el.setAttribute('role', 'alert')
    el.setAttribute('aria-live', 'polite')
    container.appendChild(el)
  }
  el.textContent = message
}

export function clearError(container: HTMLElement): void {
  const el = container.querySelector<HTMLParagraphElement>('.error-message')
  if (el) el.textContent = ''
}
